export const BuildInfo = {timestamp:1791926993000}
